import React from 'react'

import DefaultLayout from '../components/layout'
import SEO from '../components/seo'

const posts = [
  {
    title: 'Workslop',
    url: 'https://build.ms/2026/3/23/workslop/',
    date: 'March 23, 2026',
    description:
      'The bar for shipping quality work hasn‘t lowered just because AI can generate code in minutes — and if you‘re accepting AI output without reviewing it, you‘re part of the problem.',
  },
  {
    title: 'Small Steps For Agent-Friendly Codebases',
    url: 'https://build.ms/2026/3/11/small-steps-for-agent-friendly-codebases/',
    date: 'March 11, 2026',
    description:
      'Updating an open source library taught me a valuable lesson for making your codebase agent-friendly — small steps can have a big payoff.',
  },
  {
    title: 'The Hidden Cost Of Communication (A Case Against Big Companies)',
    url: 'https://build.ms/2026/2/27/the-hidden-cost-of-communication/',
    date: 'February 27, 2026',
    description:
      'Big companies are downsizing, not solely because of AI and corporate greed but because communication bottlenecks kill productivity and demoralize teams.',
  },
  {
    title: 'Automating Codex',
    url: 'https://build.ms/2026/2/12/automating-codex/',
    date: 'February 12, 2026',
    description:
      'You‘re one step away from turning Codex into a proactive assistant that tackles low-hanging fruit while you sleep.',
  },
  {
    title: 'Supporting Markdown Search For LLMs',
    url: 'https://build.ms/2026/2/2/supporting-markdown-search-for-llms/',
    date: 'February 2, 2026',
    description:
      'Learn a simple but effective technique that makes your blog more easily searchable for LLMs.',
  },
  {
    title: 'Updating Your Website For Generative Engine Optimization',
    url: 'https://build.ms/2026/1/29/updating-your-website-for-generative-engine-optimization/',
    date: 'January 29, 2026',
    description:
      'Learn how to optimize your website for generative search engines like ChatGPT, Claude, and Gemini to improve your search engine rankings.',
  },
  {
    title: 'AI Agents Are Starting To Eat SaaS (Really)',
    url: 'https://build.ms/2026/1/26/ai-agents-are-starting-to-eat-saas-really/',
    date: 'January 26, 2026',
    description:
      'AI is making it cheaper and easier for anyone to build custom software solutions. The changes from this shift will be drastic, especially for SaaS companies.',
  },
  {
    title: 'The Democratization of AI',
    url: 'https://build.ms/2026/1/21/the-democratization-of-ai/',
    date: 'January 21, 2026',
    description:
      'The barrier to building with AI has dropped thousands-fold. What happens when you give everyone the tools to implement their ideas?',
  },
  {
    title: 'The Claude Code Moment',
    url: 'https://build.ms/2026/1/19/the-claude-code-moment/',
    date: 'January 19, 2026',
    description:
      'The sudden adoption of Claude Code by non-technical people represents an important moment in time — and one that will have a lasting impact on the way we work.',
  },
  {
    title: 'Build.ms: Making Technology Accessible To Everyone',
    url: 'https://build.ms/2026/1/6/making-technology-accessible-to-everyone/',
    date: 'January 6, 2026',
    description:
      'Learn how to think about technology in a fast-moving world — I‘ll show you what matters and filter out the rest.',
  },
  {
    title: 'AI (Without the Hype)',
    url: 'https://build.ms/2025/12/24/ai-without-the-hype-ns-spain-2025/',
    date: 'December 24, 2025',
    description:
      'I spoke at NSSpain this year and gave a wide-ranging talk AI, building from the fundamentals to real-world uses — with something for everyone.',
  },
  {
    title: 'Codex vs. Claude Code (Today)',
    url: 'https://build.ms/2025/12/22/codex-vs-claude-code-today/',
    date: 'December 22, 2025',
    description:
      'Every AI tool has its strengths and weaknesses, and the only way to discover what they are is by using them.',
  },
  {
    title: 'Building Software From Blog Posts',
    url: 'https://build.ms/2025/12/15/building-software-from-blog-posts/',
    date: 'December 15, 2025',
    description:
      'Did you know you can just point AI at a blog post and have it build a piece of software? That‘s where we are now.',
  },
  {
    title: 'Scribblenauts For Software',
    url: 'https://build.ms/2025/12/1/scribblenauts-for-software/',
    date: 'December 1, 2025',
    description:
      'AI lets people build any tool in minutes at practically zero cost. The result? An era of personalized, on-demand software.',
  },
  {
    title: 'The Past, Present, and Future of AI Workshops with @mergesort',
    url: 'https://build.ms/2025/10/30/ai-workshops-launch/',
    date: 'October 30, 2025',
    description:
      'Six months teaching people to build with AI taught me one thing: most people are just a few questions away from learning so much.',
  },
  {
    title: 'How I Used ChatGPT Over A Long Weekend',
    url: 'https://build.ms/2025/1/1/how-i-used-chatgpt/',
    date: 'January 1, 2025',
    description:
      'Real-world examples of how I used ChatGPT over a four-day weekend, providing practical insights for anyone curious about working with large language models.',
  },
  {
    title: 'The Rule of Small and Large',
    url: 'https://build.ms/2024/12/16/the-rule-of-small-and-large/',
    date: 'December 16, 2024',
    description:
      'A personal framework for choosing projects: focus on either small projects for quick learning or large projects for meaningful impact, while avoiding the medium-sized trap.',
  },
  {
    title: 'A Mental Model For Prompting Large Language Models',
    url: 'https://build.ms/2024/11/14/prompting-large-lanuage-models/',
    date: 'November 14, 2024',
    description:
      'A practical analogy for understanding and improving how you work with AI tools like ChatGPT and Claude, moving beyond tips and tricks to develop better judgment.',
  },
  {
    title: 'Building A Customizable Framer Component',
    url: 'https://build.ms/2024/10/14/building-a-customizable-framer-component/',
    date: 'October 14, 2024',
    description:
      'A technical walkthrough of building a customizable Framer Code Component for Buttondown email signups, complete with Property Controls and open source code.',
  },
  {
    title: 'Introducing Plinky: My Love Letter To Links',
    url: 'https://build.ms/2024/5/9/introducing-plinky/',
    date: 'May 9, 2024',
    description:
      'The story behind Plinky, my personal app for saving and organizing links that makes it incredibly easy to save links for later.',
  },
  {
    title: 'The Reasoning Computer',
    url: 'https://build.ms/2023/11/10/the-reasoning-computer/',
    date: 'November 10, 2023',
    description:
      'How will we solve problems in a new era of computation, where the very foundations of how a computer is expected to work are no longer deterministic?',
  },
  {
    title: 'Coding As Creative Expression',
    url: 'https://build.ms/2022/5/21/coding-as-creative-expression/',
    date: 'May 21, 2022',
    description:
      'Exploring whether coding is art or science, and how programming serves as a creative medium for solving problems and expressing ideas through code.',
  },
]

function BuildMsPostsPage() {
  return (
    <DefaultLayout>
      <SEO
        title="Recent Blog Posts From Build.ms"
        description="A curated roundup of top posts from build.ms about engineering, product development, design, business, marketing, and AI."
      />
      <div className="clearfix post-content-box">
        <article className="article-page">
          <div className="page-content">
            <div className="wrap-content">
              <header className="header-page">
                <h1 className="page-title">Recent Blog Posts From Build.ms</h1>
              </header>

              <p>
                Here are some recent blog posts from{' '}
                <a href="https://build.ms">build.ms</a>, where I make technology
                accessible to everyone by sharing lessons about engineering,
                product development, design, business, marketing, and AI.
              </p>

              {posts.map((post) => (
                <section key={post.url} style={{ marginBottom: '1.5rem' }}>
                  <h3 style={{ marginBottom: '0.35rem' }}>
                    <a href={post.url}>{post.title}</a>{' '}
                    <span
                      style={{
                        fontSize: '0.88em',
                        fontWeight: 300,
                        opacity: 0.72,
                      }}
                    >
                      {post.date}
                    </span>
                  </h3>
                  <p>{post.description}</p>
                </section>
              ))}
            </div>
          </div>
        </article>
      </div>
    </DefaultLayout>
  )
}

export default BuildMsPostsPage
